import { Heading } from "@chakra-ui/react";
import EmailSettings from "features/Settings/Email";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import { useEffect } from "react";

export default function EmailSettingsPage() {
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("Email Settings");
    // setBackLocationName("Home");
    // setBackLocationPath("/");
    return () => {
      setBackLocationPath(null);
      setBackLocationName(null);
      setPageTitle(null);
    };
  }, [setBackLocationPath, setBackLocationName, setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <Heading mb="8" size="sm" color="fg.subtle">
          Email Settings
        </Heading>
        <EmailSettings />
      </InnerSidebar>
    </AppPage>
  );
}
